export default __webpack_public_path__ + "static/media/robot-soccer.653acd91.jpg";